import classNames from "classnames";
import CustomButton from "rivals/components/shared/CustomButton";
import styles from "rivals/components/shared/Gallery/GalleryModal/GalleryModal.module.scss";
import { GalleryToggleProps } from "rivals/components/shared/Gallery/GalleryModal/types";

export default function GalleryToggle({
  onViewChange,
  showSlideshow
}: GalleryToggleProps): JSX.Element {
  return (
    <div className={styles.toggleContainer}>
      <CustomButton
        ariaLabel="view galleries"
        className={classNames(styles.galleryIcon, {
          [styles.active]: !showSlideshow
        })}
        icon={<div className={styles.toggle} />}
        onClick={(): void => onViewChange(false)}
        philter="gallery-view"
      />
      <CustomButton
        ariaLabel="view images"
        className={classNames(styles.imageIcon, {
          [styles.active]: showSlideshow
        })}
        icon={<div className={styles.imageToggle} />}
        onClick={(): void => onViewChange(true)}
        philter="image-view"
      />
    </div>
  );
}
